var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 77,
    viewBox: "0 0 76 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 38.5,
    r: 38,
    fill: "#E42375",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.8725 27.1525C51.055 26.8725 48.2375 26.6625 45.4025 26.505V26.4875L45.0175 24.2125C44.755 22.6025 44.37 20.1875 40.275 20.1875H35.69C31.6125 20.1875 31.2275 22.4975 30.9475 24.195L30.58 26.435C28.9525 26.54 27.325 26.645 25.6975 26.8025L22.1275 27.1525C21.3925 27.2225 20.8675 27.87 20.9375 28.5875C21.0075 29.305 21.6375 29.83 22.3725 29.76L25.9425 29.41C35.1125 28.5 44.3525 28.85 53.6275 29.7775C53.68 29.7775 53.715 29.7775 53.7675 29.7775C54.4325 29.7775 55.01 29.27 55.08 28.5875C55.1325 27.87 54.6075 27.2225 53.8725 27.1525Z",
    fill: "#E42375"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6525 32.245C50.2325 31.8075 49.655 31.5625 49.06 31.5625H26.94C26.345 31.5625 25.7501 31.8075 25.3476 32.245C24.9451 32.6825 24.7175 33.2775 24.7525 33.89L25.8376 51.845C26.0301 54.505 26.2751 57.83 32.3826 57.83H43.6175C49.725 57.83 49.9701 54.5225 50.1625 51.845L51.2475 33.9075C51.2825 33.2775 51.055 32.6825 50.6525 32.245ZM40.905 49.0625H35.0775C34.3601 49.0625 33.765 48.4675 33.765 47.75C33.765 47.0325 34.3601 46.4375 35.0775 46.4375H40.905C41.6225 46.4375 42.2175 47.0325 42.2175 47.75C42.2175 48.4675 41.6225 49.0625 40.905 49.0625ZM42.375 42.0625H33.6251C32.9075 42.0625 32.3126 41.4675 32.3126 40.75C32.3126 40.0325 32.9075 39.4375 33.6251 39.4375H42.375C43.0926 39.4375 43.6875 40.0325 43.6875 40.75C43.6875 41.4675 43.0926 42.0625 42.375 42.0625Z",
    fill: "#E42375"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.0d272de8c63b9c329a1cf06fc9768551.svg";
export { ForwardRef as ReactComponent };